import * as React from 'react';

import { IDailyRentOfferForMobileSite } from '../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { EListingBannerType } from '../../constants/banner';
import { AdfoxListingBanner } from '../Adfox/AdfoxListingBanner';
import { AdfoxListingBannerWrapper } from '../Adfox/AdfoxListingBannerWrapper';
import { ParallaxBannerWrapper } from '../Adfox/ParallaxBannerWrapper';
import { ParallaxListingBanner } from '../Adfox/ParallaxListingBanner';

interface IBannerContainerProps {
  offer: IDailyRentOfferForMobileSite;
  position: number;
  bannerType: EListingBannerType;
}

export const BannerContainer = ({ offer, position, bannerType }: IBannerContainerProps) => {
  switch (bannerType) {
    case EListingBannerType.Parallax:
      return (
        <ParallaxBannerWrapper>
          <ParallaxListingBanner position={position} />
        </ParallaxBannerWrapper>
      );

    case EListingBannerType.Tgb:
      return (
        <AdfoxListingBannerWrapper>
          <AdfoxListingBanner
            offer={offer}
            params={{ p1: 'dciqj', p2: 'fkhj' }}
            bannerType={EListingBannerType.Tgb}
            position={position}
          />
        </AdfoxListingBannerWrapper>
      );

    default: {
      const exhaustiveCheck: never = bannerType;

      return exhaustiveCheck;
    }
  }
};

BannerContainer.displayName = 'BannerContainer';
